import React from 'react';
import ReactDOM from 'react-dom/client';

import CaravanParkReservation from './CaravanParkReservation';

const root = ReactDOM.createRoot(
  document.getElementById('caravan_park_reservation')
);

root.render(
  <React.StrictMode>
    <CaravanParkReservation />
  </React.StrictMode>
);
